import React from 'react';
import check from 'check-types';
import { connect } from 'react-redux';
import { addComment } from '../../../actions';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { isEmptyValue } from 'components/utils/checkValue';
import { withMsgInfo, withTranslation } from '..';
import { withRouterHooks } from '../withRouterHooks';

export const withComment = (WrapperComponent) => {
  class Comment extends React.Component {
    state = {
      isLoading: false,
    };

    onChange = ({ target }) => {
      const { name, value } = target;
      this.setState({ [name]: value });
    };

    onSubmit = async () => {
      const payload = { ...this.state };
      const { addComment, setMsgInfo, tr, navigate } = this.props;

      const formData = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        if (key === 'document') {
          if (!check.string(value) && !isEmptyValue(value)) {
            formData.append(key, value);
          }
        } else {
          // formData.append(key, value);
          formData.append(key, key === 'response_welcome' ? String(value) : value);
        }
      });

      
      try {
        this.setState({ isLoading: true });
        await addComment(formData);
        this.setState(this.clearState());
        navigate(`dashboard/`);
        setMsgInfo({ 
          success: true,
          msg: ['Comment sent successfully'],
          });
     
      } catch (e) {
        this.setState({ isLoading: false });
      }
    };

    clearState = () => {
      return Object.entries(this.state).reduce((accum, [key, value]) => {
        if (check.string(value)) {
          accum[key] = '';
        } else {
          accum[key] = null;
        }
        return accum;
      }, {});
    };
    render() {
      return (
        <WrapperComponent
          {...this.props}
          isLoading={this.state.isLoading}
          commentFormData={this.state}
          onChangeComment={this.onChange}
          onSubmitComment={this.onSubmit}
          commentFormSubmitting={this.state.isLoading}
        />
      );
    }
  }
  
  const WithComment = connect(null, {
    addComment,
  })(Comment);
  hoistNonReactStatics(WithComment, WrapperComponent);
  return withMsgInfo(WithComment, withTranslation, withRouterHooks);
};
